import styled from 'styled-components';
import { Text } from '@grupoboticario/flora-react';

import { GenericCardWrapper } from '../../sharedStyles';

export const CardDeclarationWrapper = styled(GenericCardWrapper)`
  display: flex;
  flex-direction: row;
  padding: 18px 20px 18px 28px;
  margin-bottom: 10px;
  position: relative;
  @media (max-width: 570px) {
    flex-direction: column;
  }
`;

export const CardDeclarationInfo = styled.div`
  flex: 2;
  gap: 8px;
  @media (max-width: 570px) {
    flex: 1;
    gap: 0;
  }
`;

export const CardDeclarationTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 29px;
  span {
    color: ${({ theme }) => theme.colors.error};
  }
`;

export const CardDeclarationUploadInput = styled.div`
  flex: 1;
  align-items: center;
  display: flex;
  max-width: 158px;
  @media (max-width: 570px) {
    max-width: 100%;
  }
`;

export const CardDeclarationRadio = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 17px;
  div.radioBlock {
    flex: 1;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: ${({ theme }) => theme.colors.text};
    button[role='radio'] {
      vertical-align: top;
      margin-right: 9px;
    }
  }
`;

export const CardDeclarationRadioText = styled(Text)`
  display: inline-block;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.text};
  max-width: calc(100% - 60px);
  width: 100%;
  vertical-align: top;
  user-select: none;
`;

export const CardDeclarationNegative = styled.div`
  width: 100%;
  svg {
    display: block;
    margin: 9px auto;
  }
  span {
    display: block;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: center;
  }
`;
